import { render } from "./ReportDashboard.vue?vue&type=template&id=8f2e26be&scoped=true"
import script from "./ReportDashboard.vue?vue&type=script&lang=js"
export * from "./ReportDashboard.vue?vue&type=script&lang=js"

import "./ReportDashboard.vue?vue&type=style&index=0&id=8f2e26be&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2e26be"]])

export default __exports__